import { DeliveryTimeUnit } from '@lib/util';

export interface IDemandProductDelivery {
    deliveryTime: number;
    deliveryTimeUnit: DeliveryTimeUnit;
    preferredDeliveryDate?: string;
    partialDeliveryPossible: boolean;
}

export class DemandProductDelivery implements IDemandProductDelivery {
    public deliveryTime = 0;
    public deliveryTimeUnit: DeliveryTimeUnit = DeliveryTimeUnit.WEEKS;
    public partialDeliveryPossible = false;
    public preferredDeliveryDate?: string;

    public static fromDto(dto: IDemandProductDelivery): DemandProductDelivery {
        const delivery = new DemandProductDelivery();
        Object.assign(delivery, dto);

        return delivery;
    }
}
